import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { site } from '../../data/site';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
export function ParentFeedback() {
  return <section id="families" aria-label="Parent feedback" className="bg-paper py-20 lg:py-28" data-id="element-142" data-mp="156ypn06459l6">
      <Container data-id="element-143" data-mp="1a5t5pucp4k1l">
        <Reveal className="grid gap-8 lg:grid-cols-12" data-id="element-144" data-mp="1a59xj5cula0r">
          <p className="font-display text-lg font-semibold uppercase tracking-[0.12em] text-muted lg:col-span-3 lg:pt-4" data-id="element-145" data-mp="1xtsx8whu0eh8">
            From a Bates parent
          </p>
          <figure className="lg:col-span-9" data-id="element-146" data-mp="22v9wknko3svp">
            <span aria-hidden="true" className="block font-display text-[6rem] font-bold leading-[0.6] text-brand" data-id="element-147" data-mp="1o3hrr5ii1x88">
              “
            </span>
            <blockquote className="text-balance mt-4 text-[1.75rem] font-medium leading-[1.25] tracking-[-0.015em] sm:text-[2.25rem] lg:text-[2.7rem]" data-id="element-148" data-mp="1t19hptzl399s">
              <p data-id="element-149" data-mp="2lkykvxu0kb23">…they get individualized training that is suited to them. They have matured and love going to class.</p>
            </blockquote>
            <figcaption className="mt-8 flex flex-col gap-4 border-t border-line pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-150" data-mp="28lp82zaur10c">
              <span data-id="element-151" data-mp="2ied0ziypokts">
                <span className="block font-semibold" data-id="element-152" data-mp="2iemwtn6ftm7e">Kerrie Kiefer</span>
                <span className="block text-sm text-muted" data-id="element-153" data-mp="2dmlb7andqj4p">Parent feedback from the Bates Taekwondo testimonials</span>
              </span>
              <a href={site.testimonialsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center gap-1.5 text-[15px] font-semibold text-ink underline decoration-brand decoration-2 underline-offset-4 hover:text-brand" data-id="element-154" data-mp="2rcyjje46nzuk">
                Read testimonials
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="16xwnvwamqga3" />
                <span className="sr-only" data-id="element-156" data-mp="11zv396xk28wi"> (opens in a new tab)</span>
              </a>
            </figcaption>
          </figure>
        </Reveal>
      </Container>
    </section>;
}